import React from 'react';

import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import IconCoffeeCup from 'components/icons/coffee-cup';
import IconMobileNavLogo from 'components/icons/mobile-nav-home';
import IconOffersTH from 'components/icons/offers-th';
import TimsBarcode from 'components/icons/tims-barcode';
import { useLoyaltyActiveCard } from 'hooks/loyalty';
import { CustomEventNames, useMParticleContext } from 'state/mParticle';
import { useUIContext } from 'state/ui';
import { routes } from 'utils/routing';

import { NavLink, iconSize } from './helpers';
import { getAboutLink, getAccountLink } from './nav-links-item';
import { IconWrap, NavLinkText } from './styled';
import { NavButton } from './styled-link';
import { GetNavLinksParams, NavigationMobileTab } from './types';

const BrandLogo = styled(IconMobileNavLogo)<{ viewBox: string }>`
  height: 30px;
`;

const homeTextKey = 'home';
const orderTextKey = 'order';
const offersTextKey = 'offers';

export const getNavLinks = ({
  enableAccountInFooter,
  menuHref,
  formatMessage,
}: GetNavLinksParams): NavigationMobileTab[] => {
  return [
    {
      selectedHrefs: [routes.base],
      Component: () => (
        <NavLink
          data-testid="home-mobile"
          to={routes.base}
          requiresExactMatch
          navBarText={homeTextKey}
        >
          <IconWrap>
            <BrandLogo viewBox="0 0 24 24" />
          </IconWrap>
          <NavLinkText>{formatMessage({ id: homeTextKey })}</NavLinkText>
        </NavLink>
      ),
    },
    {
      selectedHrefs: [menuHref],
      Component: () => (
        <NavLink data-testid="order-mobile" to={menuHref} navBarText={orderTextKey}>
          <IconWrap>
            <IconCoffeeCup height={iconSize} />
          </IconWrap>
          <NavLinkText>{formatMessage({ id: orderTextKey })}</NavLinkText>
        </NavLink>
      ),
    },
    {
      selectedHrefs: [],
      Component: () => {
        const { showRewardsTab, hideDrawer, isShowingDrawer } = useUIContext();
        const { activeCard } = useLoyaltyActiveCard();
        const navigate = useNavigate();
        const scanTextKey = 'scan';
        const linkText = formatMessage({ id: scanTextKey });
        const mParticle = useMParticleContext();

        return (
          <NavButton
            className={isShowingDrawer ? 'active' : ''}
            onClick={() => {
              mParticle.logNavBarClickEvent(scanTextKey);
              mParticle.logNavigationClick(CustomEventNames.NAV_CLICK, { linkText, linkTo: '/' });
              if (!activeCard) {
                return navigate(routes.signIn);
              }
              return isShowingDrawer ? hideDrawer() : showRewardsTab();
            }}
          >
            <IconWrap>
              <TimsBarcode width={iconSize} />
            </IconWrap>
            <NavLinkText>{linkText}</NavLinkText>
          </NavButton>
        );
      },
    },
    {
      selectedHrefs: [routes.orders],
      Component: () => (
        <NavLink data-testid="offers-mobile" to={routes.offers} navBarText={offersTextKey}>
          <IconWrap>
            <IconOffersTH height={iconSize} />
          </IconWrap>
          <NavLinkText>{formatMessage({ id: offersTextKey })}</NavLinkText>
        </NavLink>
      ),
    },
    enableAccountInFooter ? getAccountLink({ formatMessage }) : getAboutLink({ formatMessage }),
  ];
};
